
import ContactUs from "../../components/ContactUs";
import PlanCards from "../../components/PlanCardSection";
import SliderViewSection from "../../components/SliderViewSection";
import StayInLoop from "../../components/StayInLoop";
import TestimonialSlider from "../../components/FeedbackSlider";
import {
  AllProductGif,
  CardSwapImg, Visva1,
  Visva2,
  Visva3,
  Visva4,
  Visva5,
} from "../../constant";
import ProductLanding from "../../components/Products/ProductLanding";
import FourCardsSwap from "../../components/FourCardSwapSection";


const safetyAndSustainabilityData = [
  {
    title:
      "VISVA. Turning Industrial Data into Operational Intelligence",

    subtitle:
      "VISVA connects workforce activity, equipment signals, operational records and enterprise knowledge to deliver contextual intelligence across industrial environments.",

    lists: [
      "Unified Operational Visibility",
      "AI-Assisted Decision Support",
      "Connected Enterprise Intelligence",
    ],

    mediaUrl:
      Visva1
  },

  {
    title:
      "Smarter Safety Through Contextual Awareness.",

    subtitle:
      "VISVA analyzes field observations, incidents, SOPs and operational patterns to improve workforce coordination and safety responsiveness.",

    lists: [
      "Intelligent Safety Assistance",
      "Context-Aware Recommendations",
      "Faster Incident Understanding",
    ],

    mediaUrl:
      Visva2
  },

  {
    title:
      "From Equipment Signals to Actionable Outcomes.",

    subtitle:
      "VISVA interprets machine telemetry, operational logs and maintenance history to identify patterns, operational deviations and optimization opportunities.",

    lists: [
      "Operational Pattern Recognition",
      "Asset Behavior Analysis",
      "Production & Reliability Insights",
    ],

    mediaUrl:
      Visva3
  },

  {
    title:
      "Contextual Insights for Sustainable Operations.",

    subtitle:
      "VISVA simplifies sustainability analysis by connecting emissions data, audits, compliance records and operational activities into a unified intelligence layer.",

    lists: [
      "Sustainability Data Interpretation",
      "ESG Knowledge Assistance",
      "Operational Sustainability Visibility",
    ],

    mediaUrl:
      Visva4
  },

  {
    title:
      "AI That Understands Industrial Operations.",

    subtitle:
      "VISVA enables intelligent copilots and autonomous agents capable of assisting teams with operational queries, enterprise knowledge retrieval and workflow guidance.",

    lists: [
      "Enterprise AI Copilots",
      "Contextual Knowledge Retrieval",
      "Intelligent Workflow Assistance",
    ],

    mediaUrl:
      Visva5
  },
];




const AuroraSRPPlans = [
  {
    title: "AI Core",
    subtitle: "Designed for industrial organizations adopting connected intelligence and operational AI workflows.",
    features: [
      "Edge Device Connectivity",
      "Real-Time Operational Telemetry",
      "Workforce & Asset Data Streams",
      "Standard AI Dashboards",
      "Event & Alert Engine"
    ],
  },
  {
    title: "AI Intelligence Layer",
    subtitle: "Built for enterprises requiring contextual analytics, machine intelligence and operational reasoning.",
    features: [
      "Multi-Source Data Correlation",
      "AI-Driven Operational Analytics",
      "Machine Utilization Intelligence",
      "Behavioral Pattern Detection",
      "Workflow & Event Automation",
      "Contextual Operational Dashboards",
    ],
    popular: true,
  },
  {
    title: "Autonomous AI Stack",
    subtitle: "Purpose-built for industrial ecosystems leveraging AI copilots, autonomous agents and contextual enterprise intelligence.",
    features: [
      "Autonomous AI Agents",
      "Industrial AI Copilots",
      "Semantic Knowledge Intelligence",
      "Predictive Operational Reasoning",
      "Cross-System AI Orchestration",
      "API & Enterprise System Integration",
      "Centralized AI Command Layer",
    ],
    recommended: true,
  },
];


const testimonialsData = [
  {
    quote:
      "NetZero enabled us to streamline ESG reporting and improve sustainability visibility across operations.",
    author: "General Manager, EHS",
    note: "An Integrated Energy Enterprise",
  },
  {
    quote:
      "The platform transformed our EHS processes with real-time monitoring, analytics, and actionable insights.",
    author: "Project Safety Head",
    note: "Major Oil & Gas Operator",
  },
  {
    quote:
      "Aurora helped us connect critical industrial assets and improve operational efficiency significantly.",
    author: "Project Manager",
    note: "An Integrated Oil & Gas Operator",
  },
  {
    quote:
      "We now manage compliance, audits, and sustainability reporting from a single intelligent platform.",
    author: "Head, Digital Transformation",
    note: "A Large Mining Company",
  },
  {
    quote:
      "Implementation was seamless, and the solution scaled perfectly across our enterprise operations.",
    author: "Chief Manager – Projects",
    note: "A Large Refining Company",
  },
  {
    quote:
      "The risk engagement simplified complex reporting requirements while improving data accuracy and governance.",
    author: "Chief Risk Officer",
    note: "A Large Power Generation Company",
  },
  {
    quote:
      "Connected operational intelligence and sustainability insights helped us achieve measurable business outcomes.",
    author: "Head – Projects",
    note: "One of the Largest EPC Players",
  },
  {
    quote:
      "Real-time visibility into risks, emissions, and compliance improved our overall operational performance.",
    author: "Head – Sustainability",
    note: "A Large Defence Manufacturer",
  },
  {
    quote:
      "A modern digital transformation platform that delivers measurable impact across EHS, ESG, and operations.",
    author: "Nodal Officer, Digital Initiatives",
    note: "One of the Largest Mining Operators",
  },
];

const FourCardsSwapcardData = [
  {
    title: "Industrial Knowledge Intelligence",
    description:
      "Transform SOPs, manuals, audit records, incident reports and operational documents into contextual AI-driven knowledge accessible in real time"
  },
  {
    title: "Contextual AI for Operations",
    description:
      "Leverage LLMs and Retrieval-Augmented Generation (RAG) to provide accurate operational guidance, equipment insights and process-aware responses across industrial workflows.",
  },
  {
    title: "Autonomous AI Agents",
    description:
      "Deploy intelligent agents capable of monitoring workflows, analyzing operational events, assisting field teams and automating repetitive enterprise tasks.",
  },
  {
    title: "AI for Safety & Sustainability",
    description:
      "Enable AI-powered copilots for EHS operations, ESG reporting, compliance analysis, incident investigation and sustainability performance monitoring."
  },
];

export default function ProductVisva() {
  return (
    <>
      <ProductLanding
        title={`VISVA. Enterprise AI Powered by LLMs, RAG & Autonomous Agents`}
        subTitle={`Unlock contextual industrial intelligence through Large Language Models, Retrieval-Augmented Generation (RAG) and Agentic AI designed for operations, safety, sustainability and enterprise decision-making.`}
        isNetzero={false}
        url={AllProductGif}
      />
      <FourCardsSwap
        title={"Why VISVA?"}
        subTitle={"VISVA brings Generative AI, RAG and autonomous AI agents into industrial environments to deliver contextual intelligence for operations, safety, sustainability and enterprise decision-making."}
        cardData={FourCardsSwapcardData}
      />

      <SliderViewSection
        title={"VISVA. A Collaborative AI Platform for Industrial Enterprises."}
        subTitle={"VISVA enables organizations to transform operational data, documents and enterprise processes into contextual insights and collaborative digital experiences."}
        data={safetyAndSustainabilityData} />
      {/* <CardCrausalView /> */}
      {/* <CardSwapSectionComponent data={safetyAndSustainabilityData} /> */}
      <TestimonialSlider testimonials={testimonialsData} />
      <PlanCards productName={"Visva"} title={"Visva Deployment Plans"} plans={AuroraSRPPlans} />
      <ContactUs />
      <StayInLoop />
    </>
  );
}
